import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Users, TrendingUp, Award, Globe, ArrowRight } from 'lucide-react';
import api from '../../utils/api';
import { formatNumber } from '../../utils/constants';

export default function AdminDashboard() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    api.get('/admin/dashboard').then(res => setData(res.data)).catch(console.error).finally(() => setLoading(false));
  }, []);

  if (loading) return <div style={{ color: 'var(--text-muted)', padding: 40 }}>Cargando dashboard...</div>;
  if (!data) return <div style={{ color: 'var(--text-muted)', padding: 40 }}>Error al cargar datos</div>;

  const totalLeads = data.tenants.reduce((s, t) => s + (t.total_leads || 0), 0);
  const totalGanados = data.tenants.reduce((s, t) => s + (t.ganados || 0), 0);
  const totalNewWeek = data.tenants.reduce((s, t) => s + (t.new_this_week || 0), 0);

  return (
    <div>
      <div style={{ marginBottom: 28 }}>
        <h1 style={{ fontSize: 26, fontWeight: 800 }}>Panel de Administración</h1>
        <p style={{ color: 'var(--text-muted)', fontSize: 14, marginTop: 4 }}>Vista general de todos los clientes</p>
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 16, marginBottom: 28 }}>
        <div className="stat-card">
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 4 }}><Globe size={18} style={{ color: 'var(--accent)' }} /><span className="stat-label">Clientes activos</span></div>
          <div className="stat-value">{data.total_tenants}</div>
        </div>
        <div className="stat-card">
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 4 }}><Users size={18} style={{ color: 'var(--accent)' }} /><span className="stat-label">Total de leads</span></div>
          <div className="stat-value">{formatNumber(totalLeads)}</div>
        </div>
        <div className="stat-card">
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 4 }}><Award size={18} style={{ color: 'var(--success)' }} /><span className="stat-label">Ganados</span></div>
          <div className="stat-value">{formatNumber(totalGanados)}</div>
        </div>
        <div className="stat-card">
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 4 }}><TrendingUp size={18} style={{ color: 'var(--warning)' }} /><span className="stat-label">Leads esta semana</span></div>
          <div className="stat-value">{formatNumber(totalNewWeek)}</div>
        </div>
      </div>
      <div className="card">
        <h2 style={{ fontSize: 18, fontWeight: 700, marginBottom: 16 }}>Clientes</h2>
        <div className="table-container">
          <table><thead><tr><th>Cliente</th><th>Subdominio</th><th>Total leads</th><th>Ganados</th><th>Nuevos (semana)</th><th></th></tr></thead>
            <tbody>
              {data.tenants.map(t => (
                <tr key={t.id}>
                  <td style={{ fontWeight: 600 }}>{t.name}</td>
                  <td><span style={{ color: 'var(--accent)' }}>{t.subdomain}.udream.app</span></td>
                  <td>{formatNumber(t.total_leads)}</td>
                  <td style={{ color: 'var(--success)' }}>{formatNumber(t.ganados)}</td>
                  <td>{formatNumber(t.new_this_week)}</td>
                  <td><button className="btn btn-ghost btn-sm" onClick={() => navigate('/clients/' + t.id)}><ArrowRight size={14} /></button></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
